<template>
    <div id="wrapper">
        <SidebarView :coaReconsile="true" :accounts="true" :accounts-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                    <!-- <div class="card card-shape home-box">
              
            </div> -->
                    <div>
                        <b-card no-body class="card-shape home-box">
                            <b-tabs card>
                                <b-tab title="Reconcile Amount" active>
                                    <reconcile-amount />
                                </b-tab>
                                <!-- <b-tab title="Reconcile Dr/Cr">
                                    <reconcile-debit-credit />
                                </b-tab> -->
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
         <ChatBot />
         
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ReconcileAmount from "./ReconcileAmount.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
// import ReconcileDebitCredit from "./ReconcileDebitCredit.vue";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        ReconcileAmount,
        ChatBot,
        // ReconcileDebitCredit
    },
};
</script>